import React, { useContext, useState } from 'react'
import { navigate } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { StoreContext } from '../../../context/store-context';
import { goToCheckout, isAvailable } from '../../../utils/helpers';
import Button from '../../Button';

const UpsellProductItem = ({ product, modal }) => {
  const { title } = modal.info;
  const { allProducts, showModal, addVariantToCart, setNotificationText, cart } = useContext(StoreContext);
  const [quantity, setQuantity] = useState(1);

  const productHasVariants = product.variants.length > 1;
  const productInfo = allProducts.find(
    (item) => item.handle === product.handle
  );

  const handleNavigate = () => {
    showModal(false);
    navigate(`/products/${product.handle}`);
  };

  const handleAddToCart = () => {
    const note = {
      key: 'note_added_modal_upsell',
      value: 'Added item from preCheckoutModal',
    };
    addVariantToCart(productInfo.variants[0].storefrontId, quantity, [], false, productInfo, null, false, note)
      .then(() => {
        setNotificationText(title);
        showModal(false);
      })
      .then(() => goToCheckout(cart));
  };
  return (
    <div className='upsell-product-item'>
      {product.media[0].preview_image?.src && (
        <LazyLoadImage
          alt={product.title}
          effect='blur'
          src={
            product.media[0].preview_image?.src
          }
        />
      )}
      <div className='upsell-product-item__content'>
        <p className='upsell-product-item__title'>{product.title}</p>
        <div className='upsell-product-item__action'>
          <div className='upsell-product-item__action-quantity-price'>
            {!productHasVariants && <div className='cart-item__qty'>
              <span className='cart-item__qty-minus' onClick={() => setQuantity(quantity - 1)}>-</span>
              <p>{quantity}</p>
              <span className='cart-item__qty-plus' onClick={() => setQuantity(quantity + 1)}>+</span>
            </div>}
            <div className='upsell-product-item__action-price'>
              <p>£{productInfo.variants[0].price}</p>
            </div>
          </div>
        </div>
        {!productHasVariants ?
          <Button
            buttonText='add'
            product={productInfo}
            isAction
            availableForSale={isAvailable(productInfo)}
            isDark
            isButtonCart
            handleClick={() => handleAddToCart()}
            isNoMargin
            isButtonCartUpsell
          /> :
          <Button
            buttonText='customise'
            product={productInfo}
            isAction
            availableForSale={isAvailable(productInfo)}
            isDark
            isButtonCart
            handleClick={handleNavigate}
            isNoMargin
            isButtonCartUpsell
          />
        }
      </div>
    </div>
  )
}

export default UpsellProductItem